
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Buildings</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="site?.projectId &amp;&amp; site?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: site?.projectId}">{{ site?.projectName }}</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/sites']" [queryParams]="{projectId: site?.projectId}">Sites</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/site']" [queryParams]="{id: siteId}" *ngIf="site?.name">{{ site?.name }}</a></li>
        <li class="breadcrumb-item active">Buildings</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <div class="dropdown" *ngIf="siteId">
          <button class="btn btn-primary dropdown-toggle" data-toggle="dropdown" type="button">Building Functions</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0)" (click)="create()">Create Building</a><a class="dropdown-item" href="javascript:void(0)" (click)="deleteEnable()">Delete Buildings</a></div>
        </div>
      </list-controls>
    </div>
  </div>
  <div class="row" *ngIf="deleteMode">
    <div class="col">
      <div class="rd-card">
        <div class="rd-col rd-col-3">
          <button class="btn btn-primary" type="button" (click)="deleteCancel()">Cancel</button>
        </div>
        <div class="rd-col rd-col-3"></div>
        <div class="rd-col rd-col-3">
          <button class="btn btn-primary" type="button" (click)="deleteConfirm()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="createMode">
    <div class="col">
      <div class="card-item rd-card">
        <property-container>
          <property-item>
            <h4 class="rd-col rd-col-1 rd-card-sub-header">Building Name</h4>
          </property-item>
        </property-container>
        <div class="rd-card-inner">
          <property-container>
            <property-item class="rd-col rd-col-3"></property-item>
            <property-item class="rd-col rd-col-3">Name</property-item>
            <property-item class="rd-col rd-col-3"></property-item>
          </property-container>
          <property-container>
            <property-item class="rd-col rd-col-3"></property-item>
            <property-item class="rd-col rd-col-3">
              <input class="form-control" [(ngModel)]="newBuilding.name">
            </property-item>
            <property-item class="rd-col rd-col-3"></property-item>
          </property-container>
        </div>
        <div class="rd-card-footer">
          <div class="rd-col rd-col-3">
            <button class="btn btn-primary" (click)="cancel()">Cancel</button>
          </div>
          <div class="rd-col rd-col-3"></div>
          <div class="rd-col rd-col-3">
            <button class="btn btn-primary" (click)="save(newBuilding)">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col" *ngIf="!loading">
      <div class="card-item rd-card" *ngFor="let building of buildings">
        <div *ngIf="!building.enableEdit">
          <property-container>
            <property-item class="rd-col rd-col-3"></property-item>
            <property-item class="rd-col rd-col-3">
              <h4 class="rd-card-sub-header">{{ building.name }}</h4>
            </property-item>
            <property-item class="rd-col rd-col-3">
              <div class="delete-button" *ngIf="deleteMode">
                <button class="btn btn-primary delete-btn delete-add-btn" *ngIf="!building.deleteFlag" type="button" (click)="deleteAdd(building)"></button>
                <button class="btn btn-primary delete-btn" *ngIf="building.deleteFlag" type="button" (click)="deleteRemove(building)"></button>
              </div>
            </property-item>
          </property-container>
          <div>
            <property-container class="rd-col-header-row">
              <property-item class="rd-col rd-col-3">Physical Address</property-item>
              <property-item class="rd-col rd-col-3">Toner Address</property-item>
              <property-item class="rd-col rd-col-3">Service Address</property-item>
            </property-container>
            <property-container>
              <property-item class="rd-col rd-col-3">
                <div class="edit-text"><span *ngIf="building.siteAddress.line1">{{ building.siteAddress.line1 }} {{ building.siteAddress.line2 }}</span><span *ngIf="!building.siteAddress.line1">No Unique Physical Address</span></div>
                <div class="edit-button">
                  <button class="btn btn-primary oi oi-pencil oi-smaller" type="button" (click)="editBuilding(building, 'physicalAddress')"></button>
                </div>
              </property-item>
              <property-item class="rd-col rd-col-3">
                <div class="edit-text"><span *ngIf="building.tonerAddress.line1">{{ building.tonerAddress.line1 }} {{ building.tonerAddress.line2 }}</span><span *ngIf="!building.tonerAddress.line1">No Unique Toner Address</span></div>
                <div class="edit-button">
                  <button class="btn btn-primary oi oi-pencil oi-smaller" type="button" (click)="editBuilding(building, 'tonerAddress')"></button>
                </div>
              </property-item>
              <property-item class="rd-col rd-col-3">
                <div class="edit-text"><span *ngIf="building.serviceAddress.line1">{{ building.serviceAddress.line1 }} {{ building.serviceAddress.line2 }}</span><span *ngIf="!building.serviceAddress.line1">No Unique Service Address</span></div>
                <div class="edit-button">
                  <button class="btn btn-primary oi oi-pencil oi-smaller" type="button" (click)="editBuilding(building, 'serviceAddress')"></button>
                </div>
              </property-item>
            </property-container>
            <property-container class="rd-col-header-row">
              <property-item class="rd-col rd-col-3">Toner Contact</property-item>
              <property-item class="rd-col rd-col-3">Service Contact</property-item>
              <property-item class="rd-col rd-col-3">Number of Floors</property-item>
            </property-container>
            <property-container>
              <property-item class="rd-col rd-col-3">
                <div class="edit-text"><span *ngIf="building.tonerContact.firstName">{{ building.tonerContact.firstName }} {{ building.tonerContact.lastName }}</span><span *ngIf="!building.tonerContact.firstName">No Unique Toner Contact</span></div>
                <div class="edit-button">
                  <button class="btn btn-primary oi oi-pencil oi-smaller" type="button" (click)="editBuilding(building, 'tonerContact')"></button>
                </div>
              </property-item>
              <property-item class="rd-col rd-col-3">
                <div class="edit-text"><span *ngIf="building.breakfixContact.firstName">{{ building.breakfixContact.firstName }} {{ building.breakfixContact.lastName }}</span><span *ngIf="!building.breakfixContact.firstName">No Unique Service Contact</span></div>
                <div class="edit-button">
                  <button class="btn btn-primary oi oi-pencil oi-smaller" type="button" (click)="editBuilding(building, 'serviceContact')"></button>
                </div>
              </property-item>
              <property-item class="rd-col rd-col-3">
                <div class="edit-text"><span *ngIf="building.floors">{{ building.floors.length }}</span></div>
                <div class="edit-button">
                  <button class="btn btn-primary oi oi-pencil oi-smaller" type="button" (click)="editBuilding(building, 'floors')"></button>
                </div>
              </property-item>
            </property-container>
          </div>
        </div>
        <div *ngIf="building.enableEdit">
          <div *ngIf="building.currentIndex === 'name'">
            <property-container>
              <property-item>
                <h4 class="rd-col rd-col-1 rd-card-sub-header">Building Name</h4>
              </property-item>
            </property-container>
            <div class="rd-card-inner">
              <property-container>
                <property-item class="rd-col rd-col-3"></property-item>
                <property-item class="rd-col rd-col-3">Name</property-item>
                <property-item class="rd-col rd-col-3"></property-item>
              </property-container>
              <property-container>
                <property-item class="rd-col rd-col-3"></property-item>
                <property-item class="rd-col rd-col-3">
                  <input class="form-control" [(ngModel)]="building.tempName">
                </property-item>
                <property-item class="rd-col rd-col-3"></property-item>
              </property-container>
            </div>
            <div class="rd-card-footer">
              <div class="rd-col rd-col-3">
                <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
              </div>
              <div class="rd-col rd-col-3"></div>
              <div class="rd-col rd-col-3">
                <button class="btn btn-primary" (click)="saveEdit(building, 'name')">Save</button>
              </div>
            </div>
          </div>
          <div *ngIf="building.currentIndex === 'physicalAddress'">
            <form [formGroup]="building.physicalAddressForm" (ngSubmit)="saveEdit(building, 'physicalAddress')">
              <property-container>
                <property-item>
                  <h4 class="rd-col rd-col-1 rd-card-sub-header">Physical Address</h4>
                </property-item>
              </property-container>
              <div>
                <property-container>
                  <property-item class="rd-col rd-col-3">Street Address</property-item>
                  <property-item class="rd-col rd-col-3">Line 2</property-item>
                  <property-item class="rd-col rd-col-3">Country</property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="line1" name="line1">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="line2" name="line2">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <select-country [inputId]="'modifyAddressCountry'" formControlName="country" [inputName]="'country'"></select-country>
                  </property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">City</property-item>
                  <property-item class="rd-col rd-col-3">Region</property-item>
                  <property-item class="rd-col rd-col-3">Postal Code</property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="city" name="city">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <select-region formControlName="region" [countryId]="building?.physicalAddressForm?.controls?.country?.value"></select-region>
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="postalCode" name="postalCode">
                  </property-item>
                </property-container>
              </div>
              <div class="rd-card-footer">
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
                </div>
                <div class="rd-col rd-col-3"></div>
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="building.currentIndex === 'tonerAddress'">
            <form [formGroup]="building.tonerAddressForm" (ngSubmit)="saveEdit(building, 'tonerAddress')">
              <property-container>
                <property-item>
                  <h4 class="rd-col rd-col-1 rd-card-sub-header">Toner Address</h4>
                </property-item>
              </property-container>
              <div>
                <property-container>
                  <property-item class="rd-col rd-col-3">Street Address</property-item>
                  <property-item class="rd-col rd-col-3">Line 2</property-item>
                  <property-item class="rd-col rd-col-3">Country</property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="line1" name="line1">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="line2" name="line2">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <select-country [inputId]="'modifyAddressCountry'" formControlName="country" [inputName]="'country'"></select-country>
                  </property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">City</property-item>
                  <property-item class="rd-col rd-col-3">Region</property-item>
                  <property-item class="rd-col rd-col-3">Postal Code</property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="city" name="city">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <select-region formControlName="region" [countryId]="building?.tonerAddressForm?.controls?.country?.value"></select-region>
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="postalCode" name="postalCode">
                  </property-item>
                </property-container>
              </div>
              <div class="rd-card-footer">
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
                </div>
                <div class="rd-col rd-col-3"></div>
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="building.currentIndex === 'serviceAddress'">
            <form [formGroup]="building.serviceAddressForm" (ngSubmit)="saveEdit(building, 'serviceAddress')">
              <property-container>
                <property-item>
                  <h4 class="rd-col rd-col-1 rd-card-sub-header">Service Address</h4>
                </property-item>
              </property-container>
              <div>
                <property-container>
                  <property-item class="rd-col rd-col-3">Street Address</property-item>
                  <property-item class="rd-col rd-col-3">Line 2</property-item>
                  <property-item class="rd-col rd-col-3">Country</property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="line1" name="line1">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="line2" name="line2">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <select-country [inputId]="'modifyAddressCountry'" formControlName="country" [inputName]="'country'"></select-country>
                  </property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">City</property-item>
                  <property-item class="rd-col rd-col-3">Region</property-item>
                  <property-item class="rd-col rd-col-3">Postal Code</property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="city" name="city">
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <select-region formControlName="region" [countryId]="building?.serviceAddressForm?.controls?.country?.value"></select-region>
                  </property-item>
                  <property-item class="rd-col rd-col-3">
                    <input class="form-control" type="text" formControlName="postalCode" name="postalCode">
                  </property-item>
                </property-container>
              </div>
              <div class="rd-card-footer">
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
                </div>
                <div class="rd-col rd-col-3"></div>
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="building.currentIndex === 'tonerContact'">
            <form [formGroup]="building.tonerContactForm" (ngSubmit)="saveEdit(building, 'tonerContact')">
              <property-container>
                <property-item>
                  <h4 class="rd-col rd-col-1 rd-card-sub-header">Toner Contact</h4>
                </property-item>
              </property-container>
              <div>
                <property-container>
                  <property-item class="rd-col rd-col-3"></property-item>
                  <property-item class="rd-col rd-col-3">Select Contact</property-item>
                  <property-item class="rd-col rd-col-3"></property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3"></property-item>
                  <property-item class="rd-col rd-col-3">
                    <select class="form-control" [(ngModel)]="building.tempTonerContact" [ngModelOptions]="{standalone: true}">
                      <option *ngFor="let contact of availableContacts" [ngValue]="contact">{{ contact.firstName }} {{ contact.lastName }}</option>
                      <option value="newContact">New Contact</option>
                    </select>
                  </property-item>
                  <property-item class="rd-col rd-col-3"></property-item>
                </property-container>
                <div *ngIf="building.tempTonerContact === 'newContact'">
                  <property-container>
                    <property-item class="rd-col rd-col-3">First Name</property-item>
                    <property-item class="rd-col rd-col-3">Last Name</property-item>
                    <property-item class="rd-col rd-col-3">Email Address</property-item>
                  </property-container>
                  <property-container>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="firstName" name="firstName">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="lastName" name="lastName">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="emailAddress" name="emailAddress">
                    </property-item>
                  </property-container>
                  <property-container>
                    <property-item class="rd-col rd-col-3">Phone Number</property-item>
                    <property-item class="rd-col rd-col-3">Alternative Phone Number</property-item>
                    <property-item class="rd-col rd-col-3">Locale</property-item>
                  </property-container>
                  <property-container>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="phoneNumber" name="phoneNumber">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="phoneNumber2" name="phoneNumber2">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <select-contact-locale [inputId]="'contactLocale'" formControlName="locale" name="locale" [inputName]="'contactLocale'"></select-contact-locale>
                    </property-item>
                  </property-container>
                </div>
              </div>
              <div class="rd-card-footer">
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
                </div>
                <div class="rd-col rd-col-3"></div>
                <div class="rd-col rd-col-3" *ngIf="building.tempTonerContact !== 'newContact'">
                  <button class="btn btn-primary" (click)="saveEdit(building, 'tonerContact')">Save</button>
                </div>
                <div class="rd-col rd-col-3" *ngIf="building.tempTonerContact === 'newContact'">
                  <button class="btn btn-primary" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="building.currentIndex === 'serviceContact'">
            <form [formGroup]="building.serviceContactForm" (ngSubmit)="saveEdit(building, 'serviceContact')">
              <property-container>
                <property-item>
                  <h4 class="rd-col rd-col-1 rd-card-sub-header">Service Contact</h4>
                </property-item>
              </property-container>
              <div>
                <property-container>
                  <property-item class="rd-col rd-col-3"></property-item>
                  <property-item class="rd-col rd-col-3">Select Contact</property-item>
                  <property-item class="rd-col rd-col-3"></property-item>
                </property-container>
                <property-container>
                  <property-item class="rd-col rd-col-3"></property-item>
                  <property-item class="rd-col rd-col-3">
                    <select class="form-control" [(ngModel)]="building.tempBreakfixContact" [ngModelOptions]="{standalone: true}">
                      <option *ngFor="let contact of availableContacts" [ngValue]="contact">{{ contact.firstName }} {{ contact.lastName }}</option>
                      <option value="newContact">New Contact</option>
                    </select>
                  </property-item>
                  <property-item class="rd-col rd-col-3"></property-item>
                </property-container>
                <div *ngIf="building.tempBreakfixContact === 'newContact'">
                  <property-container>
                    <property-item class="rd-col rd-col-3">First Name</property-item>
                    <property-item class="rd-col rd-col-3">Last Name</property-item>
                    <property-item class="rd-col rd-col-3">Email Address</property-item>
                  </property-container>
                  <property-container>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="firstName" name="firstName">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="lastName" name="lastName">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="emailAddress" name="emailAddress">
                    </property-item>
                  </property-container>
                  <property-container>
                    <property-item class="rd-col rd-col-3">Phone Number</property-item>
                    <property-item class="rd-col rd-col-3">Alternative Phone Number</property-item>
                    <property-item class="rd-col rd-col-3">Locale</property-item>
                  </property-container>
                  <property-container>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="phoneNumber" name="phoneNumber">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <input class="form-control" type="text" formControlName="phoneNumber2" name="phoneNumber2">
                    </property-item>
                    <property-item class="rd-col rd-col-3">
                      <select-contact-locale [inputId]="'contactLocale'" formControlName="locale" name="locale" [inputName]="'contactLocale'"></select-contact-locale>
                    </property-item>
                  </property-container>
                </div>
              </div>
              <div class="rd-card-footer">
                <div class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
                </div>
                <div class="rd-col rd-col-3"></div>
                <div class="rd-col rd-col-3" *ngIf="building.tempBreakfixContact !== 'newContact'">
                  <button class="btn btn-primary" (click)="saveEdit(building, 'serviceContact')">Save</button>
                </div>
                <div class="rd-col rd-col-3" *ngIf="building.tempBreakfixContact === 'newContact'">
                  <button class="btn btn-primary" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="building.currentIndex === 'floors'">
            <property-container>
              <property-item>
                <h4 class="rd-col rd-col-1 rd-card-sub-header">Floors</h4>
              </property-item>
            </property-container>
            <div>
              <property-container>
                <property-item class="rd-col rd-col-3"></property-item>
                <property-item class="rd-col rd-col-3">Floor Names</property-item>
                <property-item class="rd-col rd-col-3"></property-item>
              </property-container>
              <property-container *ngIf="building.tempFloors.length === 0">
                <property-item class="rd-col rd-col-3"></property-item>
                <property-item class="rd-col rd-col-3">
                  <button class="btn btn-primary" type="button" (click)="addFloors(building.tempFloors)">+</button>
                </property-item>
                <property-item class="rd-col rd-col-3"></property-item>
              </property-container>
              <property-container *ngFor="let floor of building.tempFloors">
                <property-item class="rd-col rd-col-3">
                  <div class="rd-col rd-col-2"></div>
                  <div class="rd-col rd-col-2">
                    <button class="btn btn-primary" type="button" (click)="removeFloor(building.tempFloors, floor)">-</button>
                  </div>
                </property-item>
                <property-item class="rd-col rd-col-3">
                  <input class="form-control" [(ngModel)]="floor.name">
                </property-item>
                <property-item class="rd-col rd-col-3">
                  <div class="rd-col rd-col-2">
                    <button class="btn btn-primary" type="button" (click)="addFloors(building.tempFloors)">+</button>
                  </div>
                  <div class="rd-col rd-col-2"></div>
                </property-item>
              </property-container>
            </div>
            <div class="rd-card-footer">
              <div class="rd-col rd-col-3">
                <button class="btn btn-primary" type="button" (click)="cancelEdit(building)">Cancel</button>
              </div>
              <div class="rd-col rd-col-3"></div>
              <div class="rd-col rd-col-3">
                <button class="btn btn-primary" type="button" (click)="saveEdit(building, 'floors')">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-item rd-card" *ngIf="buildings.length === 0">
        <property-container>
          <property-item>
            <h4 class="rd-col rd-col-1 rd-card-sub-header">This Site Has No Buildings</h4>
          </property-item>
        </property-container>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="deleteMode">
    <div class="col">
      <div class="rd-card">
        <div class="rd-col rd-col-3">
          <button class="btn btn-primary" type="button" (click)="deleteCancel()">Cancel</button>
        </div>
        <div class="rd-col rd-col-3"></div>
        <div class="rd-col rd-col-3">
          <button class="btn btn-primary" type="button" (click)="deleteConfirm()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>